export const FontFamilies = {
  global: "Poppins",
  profileSetup: "Inter",
  summarySection: "Poppins",
  RulesSection: "Inter",
  QualitySectionTop: "ABeeZee",
  QualitySectionBottom: "Poppins",
};
